import { DateFormatter } from '@microsoft/fast-foundation';
export class baseDateFormatter extends DateFormatter {
    constructor() {
        super(...arguments);
        this.weekdayFormat = 'short';
    }
    /**
     *
     * @param date - a valide date as either a Date, string, objec or a DateFormatter
     * @param format - The formatting for the string
     * @param locale - locale data used for formatting
     * @returns A localized string of the date provided
     * @public
     */
    getDate(date = this.date, format = {
        weekday: this.weekdayFormat,
        month: this.monthFormat,
        day: this.dayFormat,
        year: this.yearFormat,
    }, locale = this.locale) {
        const dateObj = this.getDateObject(date);
        if (!dateObj.getTime()) {
            return '';
        }
        const optionsWithTimeZone = Object.assign({ timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone }, format);
        let dateFormat = undefined;
        try {
            dateFormat = new Intl.DateTimeFormat(locale, optionsWithTimeZone).format(dateObj);
        }
        catch (error) {
            console.log(error);
        }
        if (dateFormat) {
            return dateFormat;
        }
        return new Intl.DateTimeFormat('en_US', optionsWithTimeZone).format(dateObj);
    }
}
